export const handleDeleteProject = (
  index,
  oldValue,
  oldRateio,
  oldCnpj,
  projects,
  setProjects,
  setTotalRateio,
  setTotalValueStatus,
  setTotalValueCnpj1,
  totalValueCnpj1,
  setTotalValueCnpj2,
  totalValueCnpj2,
) => {
  let array = [...projects];
  let newIndex = index;
  if (newIndex !== -1) {
    array.splice(newIndex, 1);
    setProjects(array);
  }
  setTotalRateio((v) => v - oldRateio);
  setTotalValueStatus((v) => v - oldValue);
  setTotalValueCnpj1(oldCnpj === '1' ? (v) => v - oldValue : totalValueCnpj1);
  setTotalValueCnpj2(oldCnpj === '2' ? (v) => v - oldValue : totalValueCnpj2);
};
